import React from 'react';
import CardContacto from "./components/CardContacto";

const Contacto = () => {
    return (
        <>
            <CardContacto />
        </>
    );
};

export default Contacto;
